// extracted by mini-css-extract-plugin
export default {"biobar-account-info":"styles_biobar-account-info__0Ezvk","biobar-user-name":"styles_biobar-user-name__gL-Cy","biobar-user-email":"styles_biobar-user-email__D6yZT"};